/**
 Author - Babajan
Github - https://github.com/babajanpatan
 **/

import React, {useEffect, useRef} from "react";
import NewThankYou from "./NewThankYou";
import {useRouter} from "next/router";
import PropTypes from "prop-types";

import {
  WealthyEnv
} from "helpers";


const propTypes = {
  step: PropTypes.number.isRequired
};


const NewThankYouContainer = ({
  step
}) => {
  const router = useRouter();
  const bottomRef = useRef(null);

  useEffect(() => {
    if (step === 4) {
      const apiKey = window.sessionStorage.getItem("apiKey");
      const isExistingLead = window.sessionStorage.getItem("isExistingLead");
      if (isExistingLead === "true" && apiKey?.length > 0) {
        window.location.href = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/mobile-redirect/?token=${apiKey}&url=${WealthyEnv.BUILDWEALTH_APP_URL}/profile&app_version=partner-lp`;
        sessionStorage.clear();
      }
    }
  }, []);

  const handleClose = () => {
    const cleanedPath = router.asPath.split("#")[0];
    router.replace(cleanedPath);
    window.location.href = cleanedPath;
  };

  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({behavior: "smooth", block: "start"});
    }
  };


  return (
    <NewThankYou
      bottomRef={bottomRef}
      handleClose={handleClose}
      scrollToBottom={scrollToBottom}
    />
  );
};

NewThankYouContainer.propTypes = propTypes;

export default NewThankYouContainer;
